<template>
  <FiltersWatcher
    :filters="filters"
    v-on="$listeners"
  >
    <SectionGroup gap="larger">
  
      <FormSection title="Темы">
        <SectionGroup gap="medium">
          <QAHubsPicker
            v-model="filters.hubs"
            multiple
            :hubs.sync="dynamicOptions.hubs"
          />
          <BasicCheckbox
            v-model="filters.onlyContributedHubs"
            :disabled="filters.hubs.length === 0"
            :value="1"
          >
            Искать по темам, куда есть вклад
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Местоположение">
        <SectionGroup gap="medium">
          <QALocationPicker
            v-model="filters.locations"
            multiple
            :locations.sync="dynamicOptions.locations"
          />
          <BasicCheckbox
            v-model="filters.excludeLocations"
            :disabled="filters.locations.length === 0"
            :value="1"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Дополнительно">
        <BasicCheckbox
          v-model="filters.activeLastYear"
          :value="1"
        >
          Активные за последний год
        </BasicCheckbox>
      </FormSection>
  
      <slot name="controls" />
    </SectionGroup>
  </FiltersWatcher>
</template>

<script>
  import FiltersWatcher from 'src/components/filters/FiltersWatcher/FiltersWatcher.vue';
  import BasicCheckbox from 'src/components/form/BasicCheckbox/BasicCheckbox.vue';
  import FormSection from 'src/components/form/FormSection/FormSection.vue';
  import QAHubsPicker from 'src/components/pickers/QAHubsPicker/QAHubsPicker.vue';
  import QALocationPicker from 'src/components/pickers/QALocationPicker/QALocationPicker.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

  export default {
    name: 'QAResumeFilters',
    components: {
      FiltersWatcher,
      QAHubsPicker,
      QALocationPicker,
      BasicCheckbox,
      FormSection,
      SectionGroup,
    },
    props: {
      filters: {
        type: Object,
        required: true,
      },
      dynamicOptions: {
        type: Object,
        required: true,
      },
    },
  }
</script>